exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xo-redirecting-from-xoon-warning-wrapper .modal-content{width:350px;height:auto;background-color:#fff;text-align:center;border-radius:10px}#redirectPromptBox .informationContent{padding:30px 0}#redirectPromptBox .informationContent h1,#redirectPromptBox .informationContent p{margin-left:20px;margin-right:20px}#redirectPromptBox .promptActionLinks{border-top:1px solid #dbdbdb}#redirectPromptBox .promptActionLinks a{float:left;padding:20px 8%;display:block;min-width:30%}#redirectPromptBox .promptActionLinks a.first{border-right:1px solid #dbdbdb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less
// module chunks = 1